import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=e2f25004&scoped=true"
import script from "./DesktopNav.vue?vue&type=script&lang=js"
export * from "./DesktopNav.vue?vue&type=script&lang=js"
import style0 from "./DesktopNav.vue?vue&type=style&index=0&id=e2f25004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f25004",
  null
  
)

export default component.exports